import { render, staticRenderFns } from "./EditOncecard.vue?vue&type=template&id=4add3a14&"
import script from "./EditOncecard.vue?vue&type=script&lang=js&"
export * from "./EditOncecard.vue?vue&type=script&lang=js&"
import style0 from "./EditOncecard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports